
export default {
	name : 'input-check',
	props : ['data'],
	data () {
		return {
			field : {
				value : this.data.value
			}
		}
	},
	methods : {
		changeData () {

			let vm = this

			vm.$emit('changeData', vm.field.value)

		}
	}
}



// WEBPACK FOOTER //
// ./src/components/general/fields/inputcheck/script.js